module.exports = __webpack_public_path__ + "static/media/tour-locked.298ed70e.svg";